<template>
  <div class="text-center mb-12 mt-12">
    <h2 class="relative z-10">{{ title }}</h2>

    <p class="relative z-10">{{ info }}</p>

    <div
      v-if="items"
      class="flex justify-center flex-wrap"
    >
      <div v-for="service in items" class="w-full sm:w-1/3 px-2 pb-4 " :key="service.id">
        <div
          class="text-left hover:scale-105 cursor-pointer transition-all border bg-primary rounded overflow-hidden flex flex-col h-full"
        >
          <div v-if="images != false" class="">
            <img
              v-if="service.images" :src="service.images.large" :alt="service.name"
              class="mx-auto h-40 w-full object-cover"
            />

            <div v-else-if="service.title" class="mx-auto w-full h-40 bg-action text-action flex items-center justify-center">
              <p class="text-3xl font-bold">
                {{
                  service.title
                    .charAt(0)
                    .toUpperCase()
                }}
              </p>
            </div>
          </div>

          <div class="p-3 flex flex-col justify-between flex-grow">
            <div class="">
              <h5 class="font-semibold text-lg">{{ service.title }}</h5>

              <div class="flex items-center space-x-2 mb-2">
                <b-chip>
                  <template v-if="service.priceFrom">
                    From
                  </template>
                  <span v-else>
                    {{ service.priceLabel }}
                  </span>
                </b-chip>

                <b-chip>
                  {{ service.duration }} min
                </b-chip>
              </div>

              <p v-if="service.information" class="text-sm opacity-80 overflow-hidden line-clamp-2 mb-2">{{ service.information }}</p>
            </div>

            <div class="flex items-center space-x-2 mt-4">
              <b-button
                variant="action"
                flat
                :to="`/service/${ service.id }`"
                class="w-1/2 flex-grow"
              >
                Learn more
              </b-button>

              <b-button
                v-if="locationStore.getServiceById(service.id)"
                variant="action"
                :to="`/book-now/service/${ service.id }`"
                class="w-1/2"
              >
                {{ $t('general.bookNow') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ImageUrls, Service } from '@@/types/api';

const { $api } = useNuxtApp()
const locationStore = useLocationStore()

interface Props {
  title?: string
  info?: string
  services?: string | string[]
  images?: boolean | ImageUrls
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Title',
  info: 'Info',
  services: () => [],
  images: true
})

const items = ref<Service[]>([])

locationStore.getServices()

onMounted(() => {
  fetchServices()
})

const fetchServices = async () => {
  try {
    let services = props.services

    if (services && services !== 'undefined' && typeof services === 'string') {
      services = services.split(',')
    }

    const response = await $api.location.services(services)

    const _items = response.services

    if (_items.length && services.length) {
      _items.sort((a, b) => {
        return services.indexOf(a.id) - services.indexOf(b.id)
      })
    }

    items.value = _items
  } catch (e) {
    console.log(e)
  }
}
</script>
